module.exports = __webpack_public_path__ + "static/background__bookshop2-db6ed92b8403fc777e0da845f3057ee6.jpeg";